// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/OpenSans/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/OpenSans/OpenSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/OpenSans/OpenSans-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/NotoSerif/NotoSerif-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/NotoSerif/NotoSerif-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/NotoSerif/NotoSerif-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/IconFonts/bibleFont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'OpenSans-Regular';
  font-weight: 400;
  src:
    local('OpenSans-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
@font-face {
  font-family: 'OpenSans-Bold';
  font-weight: 700;
  src:
    local('OpenSans-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
@font-face {
  font-family: 'OpenSans-Italic';
  font-weight: 400;
  font-style: italic;
  src:
    local('OpenSans-Italic'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}
@font-face {
  font-family: 'NotoSerif-Regular';
  font-weight: 400;
  src:
    local('NotoSerif-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
  font-family: 'NotoSerif-Bold';
  font-weight: 700;
  src:
    local('NotoSerif-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
  font-family: 'NotoSerif-Italic';
  font-weight: 400;
  font-style: italic;
  src:
    local('NotoSerif-Italic'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

@font-face {
  font-family: 'bibleFont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
  font-family:
    'Open Sans',
    -apple-system,
    BlinkMacSystemFont,
    'Roboto',
    'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
}

#root {
  display: flex;
  height: 100%;
  box-sizing: border-box;
  /* Slight lift from viewport edge; notched devices use env() */
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

input:focus,
textarea:focus {
  outline: none;
}

/* Web audio player */

.rhap_container {
  box-shadow: unset;
  padding: 0;
  background-color: transparent;
}

.rhap_time {
  width: 50px;
}

.rhap_current-time {
  text-align: left;
}

.rhap_total-time {
  text-align: right;
}

.rhap_additional-controls,
.rhap_main-controls,
.rhap_volume-controls {
  flex: 1;
}

.rhap_main-controls-button,
.rhap_button-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.rhap_main-controls {
  margin-right: 15px;
  margin-left: 10px;
}

.rhap_progress-bar {
  height: 3px;
}

.rhap_progress-indicator {
  width: 15px;
  height: 15px;
  top: -6px;
  margin-left: -7.5px;
}

.rhap_volume-bar {
  height: 3px;
}

.theme-light .rhap_progress-filled,
.theme-light .rhap_progress-indicator {
  background-color: #c12034;
}

.theme-dark .rhap_time {
  color: #fff;
}

.theme-sepia .rhap_download-progress,
.theme-sepia .rhap_volume-bar {
  background-color: #c0b3a4;
}

.theme-sepia .rhap_progress-indicator {
  background: #353535;
}

.theme-sepia .rhap_volume-indicator {
  background: #867864;
}

.theme-sepia .rhap_progress-filled {
  background: #353535;
}

.theme-dark .rhap_progress-filled,
.theme-dark .rhap_progress-indicator {
  background-color: #fff;
}

.theme-dark .rhap_volume-indicator {
  background: #ccc;
  opacity: 1;
}

.theme-dark .rhap_download-progress,
.theme-dark .rhap_volume-bar {
  background-color: #606060;
}

@media (max-width: 479px) {
  .rhap_main-controls {
    margin-right: 0;
    margin-left: 0;
  }

  .rhap_main-controls-button,
  .rhap_button-clear {
    width: 30px;
  }
}

@media (max-width: 390px) {
  .rhap_additional-controls > div {
    width: 35px;
  }

  .rhap_controls-section {
    margin-left: -10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/web/index.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB;;8DAE0E;AAC5E;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB;;8DAEuE;AACzE;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB;;8DAEyE;AAC3E;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB;;8DAE4E;AAC9E;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB;;8DAEyE;AAC3E;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB;;8DAE2E;AAC7E;;AAEA;EACE,wBAAwB;EACxB,+DAAyE;AAC3E;;AAEA;;EAEE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB;;;;;;cAMY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,8DAA8D;EAC9D,gDAAgD;AAClD;;AAEA;;EAEE,aAAa;AACf;;AAEA,qBAAqB;;AAErB;EACE,iBAAiB;EACjB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,OAAO;AACT;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@font-face {\n  font-family: 'OpenSans-Regular';\n  font-weight: 400;\n  src:\n    local('OpenSans-Regular'),\n    url(../../assets/fonts/OpenSans/OpenSans-Regular.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'OpenSans-Bold';\n  font-weight: 700;\n  src:\n    local('OpenSans-Bold'),\n    url(../../assets/fonts/OpenSans/OpenSans-Bold.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'OpenSans-Italic';\n  font-weight: 400;\n  font-style: italic;\n  src:\n    local('OpenSans-Italic'),\n    url(../../assets/fonts/OpenSans/OpenSans-Italic.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'NotoSerif-Regular';\n  font-weight: 400;\n  src:\n    local('NotoSerif-Regular'),\n    url(../../assets/fonts/NotoSerif/NotoSerif-Regular.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'NotoSerif-Bold';\n  font-weight: 700;\n  src:\n    local('NotoSerif-Bold'),\n    url(../../assets/fonts/NotoSerif/NotoSerif-Bold.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'NotoSerif-Italic';\n  font-weight: 400;\n  font-style: italic;\n  src:\n    local('NotoSerif-Italic'),\n    url(../../assets/fonts/NotoSerif/NotoSerif-Italic.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: 'bibleFont';\n  src: url('../../assets/fonts/IconFonts/bibleFont.ttf') format('truetype');\n}\n\nhtml,\nbody {\n  margin: 0;\n  height: 100%;\n  overflow: hidden;\n  font-family:\n    'Open Sans',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Roboto',\n    'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 14px;\n}\n\n#root {\n  display: flex;\n  height: 100%;\n  box-sizing: border-box;\n  /* Slight lift from viewport edge; notched devices use env() */\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n\ninput:focus,\ntextarea:focus {\n  outline: none;\n}\n\n/* Web audio player */\n\n.rhap_container {\n  box-shadow: unset;\n  padding: 0;\n  background-color: transparent;\n}\n\n.rhap_time {\n  width: 50px;\n}\n\n.rhap_current-time {\n  text-align: left;\n}\n\n.rhap_total-time {\n  text-align: right;\n}\n\n.rhap_additional-controls,\n.rhap_main-controls,\n.rhap_volume-controls {\n  flex: 1;\n}\n\n.rhap_main-controls-button,\n.rhap_button-clear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n}\n\n.rhap_main-controls {\n  margin-right: 15px;\n  margin-left: 10px;\n}\n\n.rhap_progress-bar {\n  height: 3px;\n}\n\n.rhap_progress-indicator {\n  width: 15px;\n  height: 15px;\n  top: -6px;\n  margin-left: -7.5px;\n}\n\n.rhap_volume-bar {\n  height: 3px;\n}\n\n.theme-light .rhap_progress-filled,\n.theme-light .rhap_progress-indicator {\n  background-color: #c12034;\n}\n\n.theme-dark .rhap_time {\n  color: #fff;\n}\n\n.theme-sepia .rhap_download-progress,\n.theme-sepia .rhap_volume-bar {\n  background-color: #c0b3a4;\n}\n\n.theme-sepia .rhap_progress-indicator {\n  background: #353535;\n}\n\n.theme-sepia .rhap_volume-indicator {\n  background: #867864;\n}\n\n.theme-sepia .rhap_progress-filled {\n  background: #353535;\n}\n\n.theme-dark .rhap_progress-filled,\n.theme-dark .rhap_progress-indicator {\n  background-color: #fff;\n}\n\n.theme-dark .rhap_volume-indicator {\n  background: #ccc;\n  opacity: 1;\n}\n\n.theme-dark .rhap_download-progress,\n.theme-dark .rhap_volume-bar {\n  background-color: #606060;\n}\n\n@media (max-width: 479px) {\n  .rhap_main-controls {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rhap_main-controls-button,\n  .rhap_button-clear {\n    width: 30px;\n  }\n}\n\n@media (max-width: 390px) {\n  .rhap_additional-controls > div {\n    width: 35px;\n  }\n\n  .rhap_controls-section {\n    margin-left: -10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
